module.exports = "/images/marriage.png?3837d3b49de01ec6d77a8b36986b9e34";